import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      openAction: 'For broker',
      title: 'For broker',
      executeAction: 'Submit',
      errorMessage: 'Error',
      successMessage: 'Request successfully sent',
      filterErrorMessage: 'Select any invoice filter',
    }
  }
}